module.exports = __webpack_public_path__ + "img/come-vict-06.4f93e82d.jpg";